var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconUserGear = function SvgIconUserGear(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.07 14.697a6.625 6.625 0 1 0-7.892 0 11.5 11.5 0 0 0-4.863 3.41 1 1 0 0 0 1.532 1.286 9.5 9.5 0 0 1 14.556 0 1 1 0 0 0 1.532-1.286 11.5 11.5 0 0 0-4.864-3.41M10.126 4.75a4.625 4.625 0 1 0 0 9.25 4.625 4.625 0 0 0 0-9.25",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 9.875a1 1 0 0 1 1 1v.497l.471-.154a1 1 0 1 1 .62 1.902l-.472.154.296.406a1 1 0 0 1-1.617 1.178l-.298-.41-.298.41a1 1 0 0 1-1.617-1.178l.296-.406-.472-.154a1 1 0 1 1 .62-1.902l.471.154v-.497a1 1 0 0 1 1-1"
  }))));
};
export default SvgIconUserGear;